// extracted by mini-css-extract-plugin
module.exports = {"label":"datafilterdaterangebox_label__3ADi-","btnCalendar":"datafilterdaterangebox_btnCalendar__2SW5z","calendarBox":"datafilterdaterangebox_calendarBox__3VRt-"};